export const OutboundQueryTypes = {
    Industry: 1,
    Family: 2,
    Category: 3,
    Location: 4,
    Country: 5,
    Facility: 6,
    Brand: 7,
    Keyword: 8,
    ReqNumbers: 9,
}